import { useEffect, useState } from "react";

/**
 * Thin bar under the topbar shown while the browser reports it's offline.
 * The service worker serves cached GETs so the app stays usable read-only;
 * this just tells the user why writes are blocked.
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" ? !navigator.onLine : false,
  );

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="offline-banner" role="status">
      Offline — showing last-saved data. Changes can't be saved until you reconnect.
    </div>
  );
}
